module.exports = __webpack_public_path__ + "media/online_learning/laptop-female-top-4164779d.jpg";